import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableMasterConfigRoutes = Loadable(
  './MasterConfigRoutes',
  () => import(/* webpackChunkName: "MasterConfig" */ './MasterConfigRoutes'),
  () => [(require as any).resolveWeak('./MasterConfigRoutes')]
);